import React, { useState } from 'react';
import "../../assets/style/Footer.css";
import { FaArrowUp, FaFacebook, FaGithub, FaLinkedin } from 'react-icons/fa';
import { useTranslation } from "react-i18next";

const Footer: React.FC = () => {
  const { t } = useTranslation('fr', { useSuspense: false });
  const [showButton, setShowButton] = useState(false);

  React.useEffect(() => {
    const handleScroll = () => setShowButton(window.scrollY > 300);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  return (
    <footer className="footer">

      {/* Wave raccord body -> footer */}
      <div className="footer__wave" aria-hidden="true">
        <svg viewBox="0 0 1440 80" preserveAspectRatio="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z" />
        </svg>
      </div>

      <div className="footer__bg">

        {/* <div className="footer__divider" /> */}

        <div className="footer__container container grid">

          {/* Brand */}
          <div className="footer__brand">
            <a href="#accueil" className="footer__logo">R</a>
            <h1 className="footer__title">Ravaka</h1>
            <span className="footer__subtitle">{t('me')}</span>
          </div>

          {/* Nav links */}
          <nav className="footer__nav">
            <p className="footer__nav-title">Navigation</p>
            <ul className="footer__links">
              <li><a href="#about" className="footer__link">À propos</a></li>
              <li><a href="#qualification" className="footer__link">{t('main.qualification')}</a></li>
              <li><a href="#skills" className="footer__link">{t('skills')}</a></li>
              <li><a href="#work" className="footer__link">{t('projects')}</a></li>
              <li><a href="#contact" className="footer__link">Contact</a></li>
            </ul>
          </nav>

          {/* Socials */}
          <div className="footer__social-wrap">
            <p className="footer__nav-title">Réseaux</p>
            <div className="footer__socials">
              <a href="https://www.facebook.com/kavaraania.aina/" target="_blank" rel="noreferrer"
                className="footer__social footer__social--facebook">
                <FaFacebook />
              </a>
              <a href="https://www.linkedin.com/in/ravakiniaina-tokifanantenana" target="_blank" rel="noreferrer"
                className="footer__social footer__social--linkedin">
                <FaLinkedin />
              </a>
              <a href="https://github.com/Ravaka15" target="_blank" rel="noreferrer"
                className="footer__social footer__social--github">
                <FaGithub />
              </a>
            </div>
          </div>

        </div>

        {/* Bottom bar */}
        <div className="footer__bottom">
          <p className="footer__copy">© Copyright 2026. Tous droits réservés</p>
        </div>

      </div>

      {/* Scroll to top */}
      <button
        className={`scroll-button ${showButton ? 'show' : ''}`}
        onClick={scrollToTop}
        aria-label="Retour en haut"
      >
        <FaArrowUp />
      </button>
    </footer>
  );
};

export default Footer;
